import { render, staticRenderFns } from "./DetailsCourier.vue?vue&type=template&id=b4479e36&scoped=true&"
import script from "./DetailsCourier.vue?vue&type=script&lang=js&"
export * from "./DetailsCourier.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCourier.vue?vue&type=style&index=0&id=b4479e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4479e36",
  null
  
)

export default component.exports